<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="disabled || readonly"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-mask="'##/##/####'"
        v-model="displayDate"
        :label="label"
        :outlined="outlined"
        :dense="dense"
        :solo="solo"
        :rules="rules"
        :disabled="disabled"
        :readonly="readonly"
        :hide-details="hideDetails"
        :clearable="clearable"
        :placeholder="placeholder"
        :error-messages="errorMessages"
        prepend-inner-icon="mdi-calendar"
        v-bind="{ ...$attrs, ...attrs }"
        v-on="on"
        @input="onInputTyped"
        @blur="validateDate"
        @click:clear="clearDate"
      />
    </template>
    <v-date-picker
      v-model="pickerDate"
      locale="pt-BR"
      :min="min"
      :max="max"
      @input="onPickerSelect"
    />
  </v-menu>
</template>

<script>
export default {
  name: "EDateCustomize",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: "",
    },
    label: {
      type: String,
      default: undefined,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      menu: false,
      displayDate: "",
      pickerDate: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.displayDate = "";
          this.pickerDate = null;
          return;
        }

        let formattedYMD = "";
        if (typeof newVal === "string" && newVal.match(/^\d{4}-\d{2}-\d{2}/)) {
          formattedYMD = newVal.split("T")[0];
        } else if (newVal instanceof Date) {
          const dia = String(newVal.getDate()).padStart(2, "0");
          const mes = String(newVal.getMonth() + 1).padStart(2, "0");
          const ano = newVal.getFullYear();
          formattedYMD = `${ano}-${mes}-${dia}`;
        }

        if (formattedYMD && formattedYMD.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [ano, mes, dia] = formattedYMD.split("-");
          this.displayDate = `${dia}/${mes}/${ano}`;
          this.pickerDate = formattedYMD;
        } else if (typeof newVal === "string" && newVal.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const [dia, mes, ano] = newVal.split("/");
          this.displayDate = newVal;
          this.pickerDate = `${ano}-${mes}-${dia}`;
        } else {
          this.displayDate = "";
          this.pickerDate = null;
        }
      },
    },
  },
  methods: {
    onInputTyped() {
      if (
        this.displayDate &&
        this.displayDate.length === 10 &&
        this.displayDate.match(/^\d{2}\/\d{2}\/\d{4}$/)
      ) {
        this.validateDate();
      }
    },
    onPickerSelect(val) {
      if (!val) {
        this.clearDate();
        return;
      }
      const [ano, mes, dia] = val.split("-");
      this.displayDate = `${dia}/${mes}/${ano}`;
      this.pickerDate = val;
      this.menu = false;
      this.$emit("input", val);
      this.$emit("change", val);
    },
    validateDate() {
      if (!this.displayDate) {
        if (this.value) {
          this.clearDate();
        }
        return;
      }

      if (!this.displayDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        if (this.pickerDate) {
          const [ano, mes, dia] = this.pickerDate.split("-");
          this.displayDate = `${dia}/${mes}/${ano}`;
        } else {
          this.clearDate();
        }
        return;
      }

      const [dia, mes, ano] = this.displayDate.split("/");
      const diaNum = parseInt(dia, 10);
      const mesNum = parseInt(mes, 10);
      const anoNum = parseInt(ano, 10);

      if (anoNum < 1900 || mesNum > 12 || diaNum > 31 || mesNum < 1 || diaNum < 1) {
        this.clearDate();
        return;
      }

      const meses30 = [4, 6, 9, 11];
      if (meses30.includes(mesNum) && diaNum > 30) {
        this.clearDate();
        return;
      }

      const isBissexto = (anoNum % 4 === 0 && anoNum % 100 !== 0) || anoNum % 400 === 0;
      if (mesNum === 2 && diaNum > (isBissexto ? 29 : 28)) {
        this.clearDate();
        return;
      }

      const mesPad = String(mesNum).padStart(2, "0");
      const diaPad = String(diaNum).padStart(2, "0");
      const formattedDate = `${ano}-${mesPad}-${diaPad}`;
      this.pickerDate = formattedDate;
      this.$emit("input", formattedDate);
      this.$emit("change", formattedDate);
    },
    clearDate() {
      this.displayDate = "";
      this.pickerDate = null;
      this.menu = false;
      this.$emit("input", null);
      this.$emit("change", null);
    },
  },
};
</script>
